import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import Select from '@lwt-helix/select';
import { useCommonStore } from '../../store/store';
import { topPerformerAgentsOptions } from '../constants';
import { Routes } from '../../common/routes/routes';
import PropTypes from 'prop-types';

const XamAgentSelector = ({ setState, setSelectedAgentId, agentMetricsAgentId, agentIdQuery }) => {

    const history = useHistory();

    const {
        xamSelectedAgent,
        getAgentInfo,
    } = useCommonStore(state => {
        const mlsAgent = state?.agentInfo?.[0]?.mlsAgentId;
        const xamSelectedAgent = topPerformerAgentsOptions.filter(agent => agent.agentId === mlsAgent?.agentId)[0];
        return ({ xamSelectedAgent, getAgentInfo: state.getAgentInfo });
    });

    const [selectedAgent, setSelectedAgent] = useState(null);

    const handleChange = async (value) => {
        if (value.agentId === agentMetricsAgentId) return;
        if (agentIdQuery === agentMetricsAgentId) history.replace(`${Routes.AGENT_PRODUCTION.BASE}`);
        const agentInfoPayload = [{ agentId: value.agentId, mlsId: value.mlsId }];
        setState((prevState) => ({
            ...prevState,
            mlsId: value.mlsId,
            agentId: value.agentId,
            agent: {
                agentId: value.agentId,
                agentName: value.agentName,
                id: value.agentId,
                mlsSid: value.mlsId,
                officeName: value.officeName,
            }
        }));
        setSelectedAgent(topPerformerAgentsOptions.filter(agent => agent.agentId === value.agentId)[0]);
        setSelectedAgentId(value.agentId);
        await getAgentInfo(agentInfoPayload);
    };

    return (
        <div className='d-flex mt-3 ml-1'>
            <Select
                className='xam-agent-selector'
                isClearable={false}
                value={selectedAgent ?? xamSelectedAgent}
                options={topPerformerAgentsOptions}
                onChange={handleChange}
            />
        </div>
    );
};

XamAgentSelector.propTypes = {
    setState: PropTypes.func.isRequired,
    setSelectedAgentId: PropTypes.func.isRequired,
    agentMetricsAgentId: PropTypes.string.isRequired,
    agentIdQuery: PropTypes.string,
};

export default XamAgentSelector;
